export default "__VITE_ASSET__BqWz$bQj__"